import { render, staticRenderFns } from "./CriteriaEdit.vue?vue&type=template&id=9303ccd2"
import script from "./CriteriaEdit.vue?vue&type=script&lang=js"
export * from "./CriteriaEdit.vue?vue&type=script&lang=js"
import style0 from "./CriteriaEdit.vue?vue&type=style&index=0&id=9303ccd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports